import React, {useEffect, useState} from 'react';
import PivotalAttachmentsApi from "../../../js/csf/pivotal/PivotalAttachmentsApi";
import PivotalTaskApi from "../../../js/csf/pivotal/PivotalTaskApi";
import {stopLoadingSpinner, startLoadingSpinner} from "./utils";
import PivotalSearchApi from "../../../js/csf/pivotal/PivotalSearchApi";

export default function CsfBrokerExportModal(props) {

  const [state, setState] = useState({
    selectCompagnie: '',
    compagniesData: [],
    errorCode: '',
  });

  useEffect(() => {

    if (props.token) {
      fetchApiData();
    }
  }, [props.token]);

  /*
  * Method to fetch the data needed to build the dashboard boxes
  * */
  const fetchApiData = () => {

    const requestData = buildCompaniesBodyDataResquest();
    const pivotalSearchApi = new PivotalSearchApi(props.apiUrl, props.apiEnv, props.token);
    pivotalSearchApi.callSearchEndpoint(requestData, '_Courtier')
      .then(response => {

        if (response &&
          response.success &&
          response.payload &&
          response.payload.data &&
          response.payload.data.rows &&
          response.payload.data.rows.length >= 0) {
          const data = response.payload.data.rows;
          setState({
            ...state,
            compagniesData: data,
            selectCompagnie: response.payload.data.rows[0].Company_Id
          });
        }  else {
          setState({
            ...state,
            errorCode: response.errorCode
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  /*
  * Method to build the body array for the search
  * */
  const buildCompaniesBodyDataResquest = () => {
    let requestData = {
      search: 'CSF_CRC_Employment_Places_REST',
      matchCondition: 1,
      startRow: 1,
      maxRows: 2000,
      parameterValues: [""]
    };
    return requestData;
  }

  /*
   * Method to handle the export button click
   */
  const handleClick = (e, $branch) => {
    document.querySelector('#export_modal .close').click();
    startLoadingSpinner();
    const requestData = buildMainBodyDataResquest($branch);
    const pivotalTaskApi = new PivotalTaskApi(props.apiUrl, props.apiEnv, props.token);
    pivotalTaskApi.callTaskEndpoint(requestData, '_Courtier')
      .then(response => {
        if (response && response.success && response.payload) {
          callDataRetrieve(response.payload);
        } else {
          stopLoadingSpinner();
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  };


  /*
  * Method to handle the input changes of the search text input
  * */
  const handleBranchExportInputChange = (event) => {
    setState({
      ...state,
      selectCompagnie: event.target.value
    });
  };


  /*
   * Method to retrieve the downloadable CSV from file ID
   */
  const callDataRetrieve = (ExportFileID) => {
    const requestData = buildFormDataRetreiveResquest(ExportFileID);
    const pivotalAttachmentsApi = new PivotalAttachmentsApi(props.apiUrl, props.apiEnv, props.token); // Use a different variable name here
    pivotalAttachmentsApi.callTaskEndpoint(requestData, '_Courtier')
      .then(blob => {
        stopLoadingSpinner();
        if (blob) {
          exportCSV(blob, `broker-${props.listType}.csv`);
        }
      })
      .catch(error => {
        stopLoadingSpinner();
        console.error(error);
      });
  };

  /*
  * Method to build the Export CSV
  * */
  const exportCSV = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };


  /*
  * Method to build the body array for the download csv request
  * */
  const buildMainBodyDataResquest = ($branch) => {
    const data = getSpecificListRequestData(props.listType);
    const requestData = {
      taskName: data.taskName, // changer pour la data de la liste sois dynamique
      methodName: data.methodName,
      types: data.types,
      parameters: $branch === true ? data.parametersBranch : data.parameters
    };

    return requestData;
  };

  /*
  * Method to build the right sort request data depending on the list type
  * */
  const getSpecificListRequestData = (type) => {
    const data = {
      compliance: {
        'taskName': "REDU Conformites View",
        'methodName': "ExportQueryToCSV",
        'types': ["System.String", "System.String", "System.String[]"],
        'parameters': ["REDU_Conformite_QUERY_REST", "REDU_Conformites_SRL_REST_Exp", []],
        'parametersBranch': ["REDU_Conformite_REST for company = ?", "REDU_Conformites_SRL_REST_Exp", [state.selectCompagnie]],
        'form': 'REDU_Conformites_View_Export',
        'fieldName': 'REDU_CSV_File'
      },
      consent: {
        'taskName': "CSF CRC Consentement",
        'methodName': "ExportQueryToCSV",
        'types': ["System.String", "System.String", "System.String[]"],
        'parameters': ["CSF_CRC_Conscentement_REST", "CSF_CRC_Consent_REST_Export", []],
        'parametersBranch': ["CSF_CRC_Consentement_REST for company = ?", "CSF_CRC_Consent_REST_Export", [state.selectCompagnie]],
        'form': 'CSF_CRC_Consentement_Export',
        'fieldName': 'CSF_CSV_File'
      },
    };
    return data[type];
  };

  /*
  * Method to build the body array for the download csv form retreive request
  * */
  const buildFormDataRetreiveResquest = (ExportFileID) => {
    const data = getSpecificListRequestData(props.listType);
    const requestData = {
      form: data.form, // changer pour que le data de la liste soit dynamique
      recordId: ExportFileID,
      fieldName: data.fieldName,
    };

    return requestData;
  };

  return (
    <div className="modal fade export-modal" id="export_modal" tabIndex="-1" role="dialog"
         aria-labelledby="export_modal_label" aria-hidden="true">
      <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h2 id="export_modal_label">{window.Drupal.t('export.personalDataDownloadPolicy.title')}</h2>
            <button type="button" className="close" data-dismiss="modal" aria-label={window.Drupal.t('lang.modal.close')}>
              <i className="icon icon-csf-close-noborder"><span className="d-none">&nbsp;</span></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="my-2"
                 dangerouslySetInnerHTML={{__html: window.Drupal.t('export.personalDataDownloadPolicy')}}>
            </div>

            <div className="form-group">
              <label htmlFor="ExportFilterSelect">{window.Drupal.t('broker.consents.export.companylist.label')}</label>
              <select id="ExportFilterSelect" onChange={handleBranchExportInputChange}>
                {state.compagniesData.map((company) => {
                  if (company.Parent_Company_Id === null) {
                    return (
                      <React.Fragment key={company.Company_Id}>
                        <option value={company.Company_Id}>{company.Company_Name}</option>
                        {state.compagniesData.map((subcompany) => {
                          if (subcompany.Parent_Company_Id === company.Company_Id) {
                            return (
                              <option key={subcompany.Company_Id} value={subcompany.Company_Id}>
                                &nbsp;&nbsp;&nbsp;{subcompany.Company_Name}
                              </option>
                            );
                          }
                          return null;
                        })}
                      </React.Fragment>
                    );
                  }
                  return null;
                })}
              </select>
            </div>

            <div className="modal-footer">
              <div className="space-between-wrapper">
                <button className="button btn-outlined btn-larger" data-dismiss="modal">{window.Drupal.t('Cancel')}</button>
                <button onClick={(e) => handleClick(e, true)}
                    className="button btn-larger" id="broker-manager-submit">
                  {window.Drupal.t('broker.consents.export.exportcompany.label')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
